/**
 * Material Unit 顯示／換算輔助（只用 toBaseNumerator／Denominator）。
 */

export function formatMtrUnitStatusLabel(status) {
  if (status === 'ACTIVE') {
    return '啟用';
  }
  if (status === 'INACTIVE') {
    return '停用';
  }
  return status || '—';
}

export function formatMtrUnitRatio(numerator, denominator) {
  const num = numerator ?? '';
  const den = denominator ?? '';
  if (num === '' && den === '') {
    return '—';
  }
  return `${num} / ${den}`;
}

/**
 * document_qty → base_qty
 * @param {number|string} documentQty
 * @param {{ toBaseNumerator?: number|string, toBaseDenominator?: number|string }} unit
 */
export function convertDocumentQtyToBase(documentQty, unit) {
  const qty = Number(documentQty);
  const num = Number(unit?.toBaseNumerator);
  const den = Number(unit?.toBaseDenominator);
  if (!Number.isFinite(qty) || !Number.isFinite(num) || !Number.isFinite(den) || den === 0) {
    return null;
  }
  return qty * num / den;
}

/**
 * base_qty → document_qty
 * @param {number|string} baseQty
 * @param {{ toBaseNumerator?: number|string, toBaseDenominator?: number|string }} unit
 */
export function convertBaseQtyToDocument(baseQty, unit) {
  const qty = Number(baseQty);
  const num = Number(unit?.toBaseNumerator);
  const den = Number(unit?.toBaseDenominator);
  if (!Number.isFinite(qty) || !Number.isFinite(num) || !Number.isFinite(den) || num === 0) {
    return null;
  }
  return qty * den / num;
}

export function resolveMtrUnitUpdatedAt(unit) {
  return unit?.updatedAt ?? unit?.record?.updatedAt ?? null;
}

export function resolveMtrUnitCode(unit) {
  return unit?.code ?? unit?.unit?.code ?? '';
}

export function findBaseMtrUnit(units = []) {
  return (units || []).find((row) => row?.baseUnit === true) ?? null;
}

export function findInactiveMtrUnitByCode(units = [], code) {
  const normalized = String(code || '').trim().toUpperCase();
  if (!normalized) {
    return null;
  }
  return (units || []).find((row) => (
    row?.status === 'INACTIVE'
    && String(resolveMtrUnitCode(row)).trim().toUpperCase() === normalized
  )) ?? null;
}

export function parsePositiveRatio(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  return n;
}
